import { Flex, Form, Input, theme, Typography } from "antd"
import { useForm } from "antd/es/form/Form"

import css from "@src/pages/registrationConfirm/index.module.css"
import { LogoutButton } from "@src/shared/componemts/LogoutButton"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"
import { useCatchFormErrors } from "@src/shared/form/base_error"
import { useBreakpoint } from "@src/shared/hooks/useBreakpoints"

type Props = {
  code?: string
  email: string
  submit: (args: { code: string; email: string }) => Promise<void>
}
export const RegistrationConfirmCodeForm = ({ code, email, submit }: Props) => {
  const [form] = useForm()
  const { submit: onSubmit } = useCatchFormErrors(form, (values) =>
    submit({ code: values.code, email }),
  )

  const { smallerThanLg } = useBreakpoint()

  return (
    <Form
      form={form}
      id="GENERATED_ID_REGISTRATIONCONFIRMCODEFORM_FORM_VOID_1"
      initialValues={{ code, email }}
      layout="vertical"
      name="confirm"
      onFinish={onSubmit}
      style={{ width: "100%" }}
    >
      <Flex gap={32} vertical>
        <Flex
          gap={16}
          justify="center"
          style={{ textAlign: "center", width: "100%" }}
          vertical
        >
          <Typography.Title
            level={4}
            style={{
              margin: 0,
              textAlign: smallerThanLg ? "center" : "left",
            }}
          >
            A confirmation code has been sent to your email{" "}
            <Typography.Text
              style={{
                color: theme.useToken().token.colorPrimary,
                textAlign: smallerThanLg ? "center" : "left",
              }}
            >
              {email}
            </Typography.Text>
          </Typography.Title>

          <Typography.Text>
            Don't forget to check your spam folder
          </Typography.Text>
        </Flex>

        <Form.Item
          id="GENERATED_ID_REGISTRATIONCONFIRMCODEFORM_TSX_FORM.ITEM_VOID_1"
          label="Code"
          name="code"
          rules={[
            {
              message: "Please input your code",
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Flex gap={20} justify="center">
          <LogoutButton />

          <SubmitButton
            buttonProps={{
              className: css.button,
              size: "middle",
              type: "primary",
            }}
            form={form}
          >
            Confirm
          </SubmitButton>
        </Flex>
      </Flex>
    </Form>
  )
}
